import { COMMON_FILTER_FIELD_IDS } from '../../reports-components/shared-filter-fields';

export const CUSTOMER_MASTER_FILTER_FIELD_IDS = Object.freeze({
  // Customer
  CustomerName: 'customerName',
  CustomerStatus: 'customerStatus',
  CustomerId: 'customerId',
  LegalName: 'legalName',
  CustomerAlias: 'customerAlias',
  DueDate: 'dueDate',
  ParentCustomer: 'parentCustomer',
  CrmId: 'crmId',
  NsErpId: 'nsErpId',
  QbErpId: 'qbErpId',
  XeroErpId: 'xeroErpId',
  StripeId: 'stripeId',
  Subsidiary: 'subsidiary',
  Country: COMMON_FILTER_FIELD_IDS.Country,
  CustomerType: 'customerType',
  CustomerCurrency: 'customerCurrency',
  TaxMethod: 'taxMethod',
  ManualReview: 'manualReview',
  PaymentProvider: 'paymentProvider',
  AutoPay: 'autoPay',
  // Contract
  ContractName: 'contractName',
  ContractStatus: 'contractStatus',
  ContractId: 'contractId',
  Currency: 'currency',
  AutoRenewal: 'autoRenewal',
  PurchaseOrder: 'purchaseOrder',
  AccountManager: 'accountManager',
  SalesforceOpportunityId: 'salesforceOpportunityId',
  NetSuiteSalesOrderId: 'netSuiteSalesOrderId',
});
